import { useEffect, useState } from "react";
import {
  getParticipantId,
  type ParticipantId,
} from "@pineseed/gui/participant";

/**
 * React hook for participant ID management
 * Automatically generates and caches unique device fingerprint
 */
export function useParticipantId() {
  const [participantId, setParticipantId] = useState<ParticipantId | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let mounted = true;

    const initializeParticipantId = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const id = await getParticipantId();

        if (mounted) {
          setParticipantId(id);
          // console.log("🔑 Participant ID initialized:", {
          //   id: id.id,
          //   fingerprint: id.deviceFingerprint.substring(0, 8) + "...",
          //   timestamp: new Date(id.timestamp).toISOString(),
          // });
        }
      } catch (err) {
        console.error("❌ Failed to initialize participant ID:", err);
        if (mounted) {
          setError(err instanceof Error ? err : new Error("Unknown error"));
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    initializeParticipantId();

    return () => {
      mounted = false;
    };
  }, []);

  return {
    participantId,
    isLoading,
    error,
    isReady: !isLoading && !error && participantId !== null,
  };
}
